module.exports = __webpack_public_path__ + "img/clientarea-details.5989466f.svg";